import { IconButton } from "@mui/material";
import { CheckRegularIcon } from "@icons/CheckRegularIcon";

export function CorrectAnswerCheckmark() {
    return (
        <IconButton
            sx={{
                padding: 0,
                width: "24px",
                height: "24px",
                backgroundColor: "var(--community-color-snow-white)",
                "&:hover": {
                    backgroundColor: "var(--community-color-snow-white)",
                },
            }}
        >
            <CheckRegularIcon
                color="var(--community-color-early-dew)"
                width="12px"
                height="12px"
            />
        </IconButton>
    );
}
